import React from 'react';
import { motion } from 'framer-motion';
import { Wrench } from 'lucide-react';
export function ObjectionHandler() {
  return <section className="w-full bg-[#f5f0e8] py-20 px-4" data-id="element-249">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-[#e2e8f0]" data-id="element-251">
          <h2 className="font-serif text-2xl md:text-3xl text-[#0f172a] mb-6" data-id="element-252">
            "Pero Yo Ya Vi Tips…"
          </h2>

          <p className="text-lg text-[#475569] mb-8 leading-relaxed" data-id="element-253">
            Sí. Y por eso estás cansada. Porque tips sin orden son como tener 30
            herramientas tiradas en el piso…
          </p>

          <div className="flex justify-center mb-8" data-id="element-254">
            <div className="bg-[#f1f5f9] p-4 rounded-full" data-id="element-255">
              <Wrench className="w-8 h-8 text-[#94a3b8]" data-id="element-256" />
            </div>
          </div>

          <p className="text-lg text-[#475569] mb-6" data-id="element-257">
            Cuando lo que necesitas es alguien diciéndote:
          </p>

          <blockquote className="font-serif text-xl md:text-2xl text-[#5b8a7a] italic font-medium" data-id="element-258">
            "Primero esto. Luego esto. Si no, esto otro."
          </blockquote>
        </motion.div>
      </div>
    </section>;
}